<script setup lang="ts">
import { ref, onMounted } from "vue";
import { Field, Filter, ReportDesign } from "../../../types/report";
import AddFilterField from "./AddFilterField.vue";
import IconComponent from "../../ui/common/IconComponent.vue";
import Buttons from "../../ui/form/Buttons.vue";
import MessageBox from "../../../services/MessageBox";

const props = defineProps<{
  report: ReportDesign;
  data?: any;
  mode?: "create" | "edit" | "view" | "showQuickView" | "toggleStatus";
}>();

defineEmits<{
  (e: "addField", data: Filter): void;
}>();

//const expandedTables = ref<string[]>([])
const showAddFilterField = ref(false)
const selectedField = ref<Field>()
//const fieldToAdd = ref<Field>()

/*const toggleTable = (tableKey: string) => {
  const index = expandedTables.value.indexOf(tableKey)
  if (index === -1) {
    expandedTables.value.push(tableKey)
  } else {
    expandedTables.value.splice(index, 1)
  }
}

const isTableExpanded = (tableKey: string) => {
  return expandedTables.value.includes(tableKey)
}*/

/*const selectField = (table: Table, field: any) => {
  fieldToAdd.value = {
    id: 'field_' + Math.random().toString(36).substring(2, 15),
    tableId: table.id,
    tableName: table.name,
    tableAlias: table.alias,
    name: field.field_name,
    alias: field.alias || field.name.replace(/[_-\s]+/g, '_').toLowerCase(),
    caption: field.caption || field.name,
    visible: true,
    aggregateFunction: undefined,
    decimals: 0,
    align: 'Left',
    type: field.field_type,
    width: 100,
    raw: false,
    rawQuery: "",
  };
  showAddFilterField.value = true
}*/

const addFilter = () => {
  /*fieldToAdd.value = {
    id: 'field_' + Math.random().toString(36).substring(2, 15),
    tableId: '',
    tableName: '',
    tableAlias: '',
    name: '',
    alias: '',
    caption: '',
    visible: true,
    aggregateFunction: undefined,
    decimals: 0,
    align: 'Left',
    type: 'string',
    width: 100,
    raw: true,
    rawQuery: "",
  };*/
  showAddFilterField.value = true
}

const addFieldToReport = (field: Filter) => {
  //emit("addField", field);
  props.report?.filters.push(field);
  showAddFilterField.value = false;
}
/*const addFieldToReport = () => {
  if (props.report && selectedField.value) {
    props.report.fields.push({
      tableField: selectedField.value.tableField,
      alias: selectedField.value.alias,
      caption: selectedField.value.caption,
      visible: selectedField.value.visible,
      align: selectedField.value.align
    })
    showAddFilterField.value = false
    selectedField.value = null
  }
}

const removeField = (index: number) => {
  if (props.report.value) {
    props.report.value.fields.splice(index, 1)
  }
}

const moveFieldUp = (index: number) => {
  if (index > 0) {
    const field = props.report.fields[index];
    props.report.fields.splice(index, 1);
    props.report.fields.splice(index - 1, 0, field);
    props.report.fields.forEach((f, i) => {
      f.sort_order = i;
    });
  }
};

const moveFieldDown = (index: number) => {
  if (index < props.report.fields.length - 1) {
    const field = props.report.fields[index];
    props.report.fields.splice(index, 1);
    props.report.fields.splice(index + 1, 0, field);
    props.report.fields.forEach((f, i) => {
      f.sort_order = i;
    });
  }
};

const removeField = (index: number) => {
  if (props.report.fields && index >= 0 && index < props.report.fields.length) {
    props.report.fields.splice(index, 1);
    props.report.fields.forEach((f, i) => {
      f.sort_order = i;
    });
  }
}

const dragStart = (index: number) => {
  draggingIndex.value = index;
};
const draggingIndex = ref<number | null>(null);
const dragOver = (index: number) => {
  if (draggingIndex.value !== null && draggingIndex.value !== index) {
    const field = props.report.fields[draggingIndex.value];
    props.report.fields.splice(draggingIndex.value, 1);
    props.report.fields.splice(index, 0, field);
    draggingIndex.value = index;
    props.report.fields.forEach((f, i) => {
      f.sort_order = i;
    });
  }
};
const drop = (_index: number) => {
  draggingIndex.value = null;
};*/

onMounted(() => {
  console.log("StepField component mounted");
  console.log(props.report);
});

const removeFilter = (index: number) => {
  MessageBox.confirm({
        title: 'Confirm Delete',
        message: 'Are you sure you want to delete the Filter (' + (props.report?.filters[index].group ? 'GROUP' : props.report?.filters[index].caption) + ')?', 
        confirmText: 'Yes, Delete',
        cancelText: "Cancel",
      }).then((confirmed: any) => {
        if (confirmed) {
          props.report?.filters.splice(index, 1);
        }
      });
}

</script>

<template>
  <div class="fields-section section" v-if="report.baseTable || report.rawReport">
    <div class="section-header" style="display: flex; align-items: center; justify-content: space-between;">
      <div id="step-name" style="display: flex; align-items: center;">
      <div class="step-indicator">Step 5</div>
      <h2 style="margin-left: 0.75rem;">Filters</h2>
      </div>
      <div id="add-raw-field">
      <Buttons
        caption="Add Filter"
        icon="Plus" 
        @click="addFilter"
      />
      </div>
    </div>

    <div class="preview-container">
      <div class="available-fields">
        <h3>Filter Fields</h3>
        <div class="field-tree">
          <div class="relative hidden md:block">
            <div v-if="props.report?.filters.length === 0" class="empty-state">
              <p>No Filters added. Click "Add Filter" to add filters to the Group.</p>
            </div>
            <table  class="divide-y divide-gray-200 dark:divide-gray-700 w-full" v-else>
              <thead class="bg-gray-50 dark:bg-gray-800">
              <tr class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                <th class="text-left"></th>
                <th class="text-left">Condition</th>
                <th class="text-left">Table Name</th>
                <th class="text-left">Field Name</th>
                <th class="text-left">Operator</th>
                <th class="text-left">Match Type</th>
                <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider sticky right-0 bg-gray-50 dark:bg-gray-800 shadow-l">...</th>
              </tr>
              </thead>
              <tbody class="bg-white text-sm py-4 dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
                <template v-for="(filter, index) in props.report?.filters" :key="index" >
              <tr class="hover:bg-gray-100 dark:hover:bg-gray-700">
                <td class="py-4"><IconComponent name="ArrowRight"></IconComponent></td>
                <td class="py-4">{{ filter.group ? 'GROUP' : filter.condition }}</td>
                <td class="py-4">{{ filter.tableAlias }}</td>
                <td class="py-4">{{ filter.fieldName }}</td>
                <td class="py-4">{{ filter.operator }}</td>
                <td class="py-4">{{ filter.matchType }}</td>
                <td class="whitespace-nowrap text-right sticky right-0 shadow-l">
                  <button
                    id="table-action-remove-table"
                   @click="removeFilter(index)"
                    class="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-600"
                    title="Delete Table"
                  >
                    <IconComponent name="Trash2"/>
                  </button>
                </td>
              </tr>
              <template v-if="filter.childFilters?.length || 0> 0">
                <tr>
                  <td class="py-4"></td>
                  <td colspan="6">
                    <table  class="divide-y divide-gray-200 dark:divide-gray-700 w-full" >
                      <tr v-for="(cFilter) in filter.childFilters" class="hover:bg-gray-100 dark:hover:bg-gray-700">
                  <td class="py-4"></td>
                <td class="py-4">{{ cFilter.condition }}</td>
                <td class="py-4">{{ cFilter.tableAlias }}</td>
                <td class="py-4">{{ cFilter.fieldName }}</td>
                <td class="py-4">{{ cFilter.operator }}</td>
                <td class="py-4">{{ cFilter.matchType }}</td>
              </tr>
                    </table>
                  </td>
                </tr>                
              </template>
              </template>
              </tbody>
            </table>
          </div>

          <div></div>
        </div>
      </div>
      <div></div>
    </div>

  </div>
  <AddFilterField
    v-if="showAddFilterField"
    :report="report"
    :mode="selectedField ? 'edit' : 'create'"
    :title="selectedField ? 'Edit' + selectedField.name + '('+ selectedField.alias +')' : 'Add New Field'"
    :data="selectedField"
    @close="showAddFilterField = false"
    @addField="addFieldToReport" />
</template>
<style scoped>


.fields-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.available-fields, .selected-fields {
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 1rem;
}

.available-fields h3, .selected-fields h3 {
  font-size: 1rem;
  margin: 0 0 1rem 0;
  color: #495057;
}

.field-tree {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.table-node {
  border: 1px solid #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.table-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background-color: white;
  cursor: pointer;
  user-select: none;
}

.table-header:hover {
  background-color: #f8f9fa;
}

.field-list {
  padding: 0.5rem;
  margin-left: 1.2rem;
  background-color: white;
}

.field-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 4px;
}

.field-item:hover {
  background-color: #f8f9fa;
}

.field-item i {
  color: #6c757d;
  font-size: 0.875rem;
}

.empty-state {
  text-align: center;
  padding: 2rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  color: #6c757d;
}
</style>